export {VscodeTabs} from './vscode-tabs.js';
